import React from "react";
import { Shield, Zap, Sun, BatteryCharging, Award, Sparkles } from "lucide-react";
import { ADVANTAGES } from "../data/catalog";

const ICONS = [Shield, Shield, Award, Zap, Sun, BatteryCharging];

export const LeduroAdvantages = () => {
  return (
    <section
      data-testid="leduro-advantages"
      className="relative bg-leduro-navy text-white py-20 md:py-28 overflow-hidden noise-overlay"
    >
      <div className="absolute inset-0 grid-lines opacity-30 pointer-events-none" />
      <div
        className="absolute right-[-200px] top-[-200px] h-[500px] w-[500px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(243,112,33,0.25), transparent 65%)" }}
      />

      <div className="relative leduro-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="leduro-eyebrow text-leduro-orange">— Why Leduro</span>
            <h2 className="mt-3 font-heading font-black tracking-tighter text-white text-3xl md:text-5xl text-balance">
              Leduro Advantages
            </h2>
          </div>
          <p className="text-white/65 max-w-md text-base md:text-lg leading-relaxed">
            Six reasons trade buyers across the Baltics specify Leduro for installations large and small.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {ADVANTAGES.map((a, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <div
                key={i}
                data-testid={`advantage-${i}`}
                className="group bg-leduro-navy hover:bg-leduro-navy-dark transition-colors p-7 lg:p-9 flex items-start gap-6"
              >
                <div className="shrink-0">
                  <div className="relative w-24 h-32 lg:w-28 lg:h-36 bg-white border-2 border-leduro-navy flex flex-col items-center justify-center">
                    <span className="absolute -top-px -left-px h-3 w-3 border-l-2 border-t-2 border-leduro-orange" />
                    <span className="absolute -top-px -right-px h-3 w-3 border-r-2 border-t-2 border-leduro-orange" />
                    <span className="absolute -bottom-px -left-px h-3 w-3 border-l-2 border-b-2 border-leduro-orange" />
                    <span className="absolute -bottom-px -right-px h-3 w-3 border-r-2 border-b-2 border-leduro-orange" />

                    <div className="text-leduro-orange font-heading font-black text-4xl lg:text-5xl leading-none">
                      {a.headline}
                    </div>
                    {a.suffix && (
                      <div className="text-leduro-orange font-heading font-black text-base lg:text-lg leading-none mt-0.5">
                        {a.suffix}
                      </div>
                    )}
                    <div className="mt-2 text-leduro-navy text-[9px] tracking-[0.22em] font-bold uppercase">
                      {a.label}
                    </div>
                  </div>
                </div>

                <div className="pt-2 flex-1">
                  <div className="flex items-center gap-2 text-leduro-orange">
                    <Icon className="h-4 w-4" />
                    <span className="text-[11px] tracking-[0.24em] uppercase font-bold">{a.label}</span>
                  </div>
                  <p className="mt-3 text-white text-base lg:text-lg leading-relaxed text-balance">
                    {a.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LeduroAdvantages;
